import { NavigationHelper, useAppDispatch } from '@common';
import { isIncludeOrEqual } from '@common';
import { Errors } from '@common';
import { ILoginForm } from '@pages/Authentication/entities/interface';
import { useLoginMutation } from '@pages/Authentication/services/AuthService';
import { updateAuthState } from '@pages/Authentication/store';
import { FormInstance } from 'antd';

export default function useLoginForm(onSuccess?: () => void) {
    const dispatch = useAppDispatch();
    const [login, { isLoading }] = useLoginMutation();

    async function onFinish(values: ILoginForm, form: FormInstance<ILoginForm>) {
        try {
            const response = await login(values).unwrap();

            sessionStorage.setItem('authToken', response.authToken);
            // "Remember me" stays on this host only. A parent-domain cookie would
            // be sent to, and readable by, every app subdomain.
            if (values?.remember) {
                localStorage.setItem('authToken', response.authToken);
            }

            if (response.authToken) {
                dispatch(updateAuthState(response));

                if (onSuccess) onSuccess();
                else {
                    NavigationHelper.Home().navigate();
                }
            }
        } catch (error: any) {
            if (isIncludeOrEqual(error?.data?.message, Errors.userNotFound)) {
                form.setFields([
                    {
                        name: 'email',
                        errors: [Errors.userNotFound],
                    },
                ]);
            }

            if (isIncludeOrEqual(error?.data?.message, Errors.passwordIncorrect)) {
                form.setFields([
                    {
                        name: 'password',
                        errors: [Errors.passwordIncorrect],
                    },
                ]);
            }
        }
    }
    return { isLoading, onFinish };
}
